<script lang="ts">
	import { yyyy, zzzz } from "../store.svelte";

	import { fade, fly } from "svelte/transition";
	import Fa from "svelte-fa";
	import { faTimes } from "@fortawesome/free-solid-svg-icons";
	import { onMount, onDestroy } from "svelte";
	let pos = { show: false, track: true, info: {} };
	let gps_id: number;
	let gps_stat: number;

	let oneDP = (number: number) => {
		// Multiply by 10, round to nearest integer, then divide by 10
		const roundedNumber = Math.round(number * 10) / 10;
		return roundedNumber;
	};

	let positionDetails = () => {
		pos.show = !pos.show;
	};

	let locateme = () => {
		if ("geolocation" in navigator) {
			const options = {
				enableHighAccuracy: true,
				timeout: 15000,
				maximumAge: 0,
			};
			let goodLocation = (position) => {
				//console.log("position: ", position);
				pos.info = {
					lng: position.coords.longitude,
					lat: position.coords.latitude,
					acc: oneDP(position.coords.accuracy),
					hdg: oneDP(position.coords.heading),
					spd: oneDP(position.coords.speed),
					alt: oneDP(position.coords.altitude),
					epc: position.timestamp,
				};
				zzzz.emit("pos.info", pos);
				yyyy.pos = pos;
				if (pos.info.acc < 10) {
					gps_stat = 1;
				} else if (pos.info.acc >= 10 && pos.info.acc < 25) {
					gps_stat = 2;
				} else {
					gps_stat = 3;
				}
			};

			let noLocation = (err) => {
				let toast_message = {
					message: err.message,
					type: "is-danger",
					dismissible: false,
					duration: 3500,
					position: "bottom-right",
				};
				zzzz.emit("toast", toast_message);

				// alert(
				// 	`Location info not good: ${JSON.stringify(
				// 		err.message,
				// 	)} |  ${JSON.stringify(err.code)}  `,
				// );
			};

			gps_id = navigator.geolocation.watchPosition(
				goodLocation,
				noLocation,
				options,
			);
			console.log("gps_id: ", gps_id);
		} else {
			/* geolocation IS NOT available */
			alert("Location not available, you may need to approve it");
		}
	};

	onMount(() => {
		locateme();
	});

	onDestroy(() => {
		navigator.geolocation.clearWatch(gps_id);
		zzzz.emit("gps.off")
		delete yyyy.pos.info;
	});
</script>

{#if !pos.show}
	<div id="locator" on:click={positionDetails}>
		<div
			class="pulsing-dot"
			class:good={gps_stat == 1}
			class:medium={gps_stat == 2}
			class:bad={gps_stat == 3}
		/>
	</div>
{/if}

{#if pos.show}
	<div
		id="position-info"
		class="box"
		transition:fly|local={{ y: 250, delay: 175 }}
	>
		<div id="line-one">
			<button on:click={positionDetails} style="color: #ff3e00">
				<Fa icon={faTimes} size="1.75x" />
			</button>
		</div>

		<table class="table is-fullwidth">
			<tbody>
				<tr><th>Longtitude</th><td> {pos.info.lng} </td></tr>
				<tr><th>Latitude</th><td> {pos.info.lat} </td></tr>
				<tr><th>Accuracy</th><td> {pos.info.acc} </td></tr>
				{#if pos.info.hdg}<tr><th>Heading</th><td> {pos.info.hdg} </td></tr>{/if}
				{#if pos.info.spd}<tr><th>Speed</th><td> {pos.info.spd} </td></tr>{/if}
				{#if pos.info.alt}<tr><th>Altitude</th><td> {pos.info.alt} </td></tr>{/if}
			</tbody>
		</table>
	</div>
{/if}

<style>
	#position-info {
		position: absolute;
		top: 15px;
		right: 15px;
		z-index: 7500;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		background-color: #ffffffe0;
		width: 375px;
		padding-left: 8.775px;
		padding-right: 8.775px;
		border-radius: 8.775px;
		backdrop-filter: blur(0.8775px) grayscale(0.8775);
		transition:
			height 0.3s ease,
			padding-top 0.3s ease;
	}

	#position-info > #line-one {
		width: 100%;
		display: flex;
		justify-content: right;
	}

	#locator {
		position: fixed;
		top: 15px;
		right: 15px;
		z-index: 500;
	}

	#locator > .pulsing-dot {
		width: 20px;
		height: 20px;
		/* background-color: grey; */
		border-radius: 50%;
		animation: pulse 2s infinite;
	}

	.pulsing-dot.medium {
		background-color: yellow;
	}
	.pulsing-dot.bad {
		background-color: red;
	}
	.pulsing-dot.good {
		background-color: green;
	}
	@keyframes pulse {
		0% {
			transform: scale(0.75);
			opacity: 0.8;
		}
		50% {
			transform: scale(1.25);
			opacity: 0.2;
		}
		100% {
			transform: scale(0.75);
			opacity: 0.8;
		}
	}

	@media only screen and (max-width: 475px) {
		#locator {
			right: 23px;
			bottom: 5px;
			top: unset;
			position: fixed;
		}
		#locator > .pulsing-dot {
			width: 20px;
			height: 20px;
			/* background-color: grey; */
			border-radius: 50%;
			animation: pulse 2s infinite;
		}
		#position-info {
			position: absolute;
			top: unset;
			bottom: 5px;
			right: 15px;
			left: 15px;
			z-index: 7500;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			background-color: #ffffffe0;
			width: unset;
			padding-left: 8.775px;
			padding-right: 8.775px;
			border-radius: 8.775px;
			backdrop-filter: blur(0.8775px) grayscale(0.8775);
			transition:
				height 0.3s ease,
				padding-top 0.3s ease;
		}

		.pulsing-dot.medium {
			background-color: yellow;
		}
		.pulsing-dot.bad {
			background-color: red;
		}
		.pulsing-dot.good {
			background-color: green;
		}
	}
</style>
